/**
 * Lalay preferences API — wraps /wp-json/lalay/v1/me/preferences.
 */

import { getToken } from './auth';

const BASE = '/wp-json/lalay/v1';

async function call(path, opts = {}) {
  const tok = getToken();
  if (!tok) return { error: 'Not signed in' };
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tok}`,
      ...(opts.headers || {}),
    },
  });
  const body = await res.json().catch(() => null);
  if (res.ok && body?.success) return { preferences: body.preferences };
  return { error: body?.message || 'Request failed', code: body?.code, status: res.status };
}

export async function fetchPreferences() {
  const res = await call('/me/preferences');
  return res;
}

export async function savePreferences(payload) {
  const res = await call('/me/preferences', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  return res;
}
